var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecosPrazosCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5979 13.3603L38.94 11.7024C38.5258 11.2882 37.8542 11.2882 37.44 11.7024L35.1109 14.0315C34.6967 14.4457 34.6967 15.1172 35.1109 15.5314L36.7688 17.1894C37.183 17.6036 37.8546 17.6036 38.2688 17.1894L40.5979 14.8603C41.0121 14.4461 41.0121 13.7745 40.5979 13.3603Z",
    fill: "#0083CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8003 43C33.6368 43 40.8003 35.8366 40.8003 27C40.8003 18.1634 33.6368 11 24.8003 11C15.9637 11 8.80026 18.1634 8.80026 27C8.80026 35.8366 15.9637 43 24.8003 43Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 27.0001C40.7994 30.1495 39.8696 33.2287 38.1269 35.8521C36.3842 38.4754 33.9062 40.5262 31.0033 41.7476C28.1004 42.969 24.9016 43.3067 21.8076 42.7183C18.7136 42.13 15.862 40.6417 13.61 38.4401L36.24 15.8101C39.1678 18.7983 40.8053 22.8166 40.8 27.0001Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8003 4H21.8003C20.6957 4 19.8003 4.89543 19.8003 6C19.8003 7.10457 20.6957 8 21.8003 8H27.8003C28.9048 8 29.8003 7.10457 29.8003 6C29.8003 4.89543 28.9048 4 27.8003 4Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8003 4.5H22.8003V11H26.8003V4.5Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 44C21.4377 44 18.151 43.003 15.3553 41.135C12.5597 39.267 10.3808 36.612 9.09407 33.5056C7.80738 30.3993 7.47073 26.9811 8.12668 23.6835C8.78262 20.3858 10.4017 17.3567 12.7792 14.9792C15.1567 12.6017 18.1858 10.9826 21.4835 10.3267C24.7812 9.67071 28.1993 10.0074 31.3056 11.2941C34.412 12.5807 37.067 14.7597 38.935 17.5553C40.803 20.3509 41.8 23.6377 41.8 27C41.795 31.5071 40.0023 35.8282 36.8152 39.0152C33.6282 42.2022 29.3071 43.9949 24.8 44ZM24.8 12C21.8333 12 18.9332 12.8797 16.4665 14.528C13.9997 16.1762 12.0771 18.5189 10.9418 21.2598C9.80652 24.0006 9.50947 27.0166 10.0882 29.9264C10.667 32.8361 12.0956 35.5088 14.1934 37.6066C16.2912 39.7044 18.964 41.133 21.8737 41.7118C24.7834 42.2906 27.7994 41.9935 30.5403 40.8582C33.2812 39.7229 35.6238 37.8003 37.2721 35.3336C38.9203 32.8668 39.8 29.9667 39.8 27C39.7955 23.0231 38.2137 19.2104 35.4017 16.3984C32.5896 13.5863 28.7769 12.0045 24.8 12Z",
    fill: "#CD992B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 36.5C21.7722 36.5 18.8 33.7757 18.8 31H21.8C21.8 31.9405 23.2531 33.5 24.8 33.5C26.2907 33.5 27.8 32.6413 27.8 31C27.8 29.155 26.1838 28.5 24.8 28.5V25.5C28.2766 25.5 30.8 27.813 30.8 31C30.8 34.1355 28.2204 36.5 24.8 36.5Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 28.5C21.9026 28.5 18.8 26.29 18.8 23C18.8 19.8645 21.3796 17.5 24.8 17.5C27.8279 17.5 30.8 20.2243 30.8 23H27.8C27.8 22.0595 26.3469 20.5 24.8 20.5C23.3093 20.5 21.8 21.3586 21.8 23C21.8 24.5489 23.5471 25.5 24.8 25.5V28.5Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 35H24.3C23.7477 35 23.3 35.4477 23.3 36V37.5C23.3 38.0523 23.7477 38.5 24.3 38.5H25.3C25.8523 38.5 26.3 38.0523 26.3 37.5V36C26.3 35.4477 25.8523 35 25.3 35Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 15H24.3C23.7477 15 23.3 15.4477 23.3 16V17.5C23.3 18.0523 23.7477 18.5 24.3 18.5H25.3C25.8523 18.5 26.3 18.0523 26.3 17.5V16C26.3 15.4477 25.8523 15 25.3 15Z",
    fill: "#00416B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.800018)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecosPrazosCor);
export default __webpack_public_path__ + "static/media/precos-prazos-cor.747b715734033b5be7ee54e453d81777.svg";
export { ForwardRef as ReactComponent };